import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

export class NbModalBase {
  modalRef: BsModalRef;
  modalResult: Subject<any> = new Subject<any>();

  hideModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  dismissModal(reason?: any) {
    this.modalResult.error(reason);
    this.hideModal();
  }

  closeModal(data?: any) {
    this.modalResult.next(data);
    this.hideModal();
  }
}
